import { render, staticRenderFns } from "./h2.vue?vue&type=template&id=f2d857cc&scoped=true&"
var script = {}
import style0 from "./h2.vue?vue&type=style&index=0&id=f2d857cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d857cc",
  null
  
)

export default component.exports